module.exports = __webpack_public_path__ + "static/media/Nov6-17.fb76f179.png";